import cn from "classnames";
import type * as React from "react";
import type { FormSectionBaseProps } from "~/components/form/Sections/FormSectionBase";
import { FormSectionBase } from "~/components/form/Sections/FormSectionBase";
import styles from "./style.module.less";
interface UnstructuredFormSectionProps extends FormSectionBaseProps {
    className?: string;
    stretchContent?: boolean;
    children?: React.ReactNode;
}
class UnstructuredFormSection extends FormSectionBase<UnstructuredFormSectionProps> {
    render() {
        return (<div className={styles.formNonExpander}>
                <div className={cn(this.props.stretchContent ? styles.stretchContent : null, this.props.className ? this.props.className : styles.unstructuredFormContent)}>{this.props.children}</div>
            </div>);
    }
    static displayName = "UnstructuredFormSection";
}
export default UnstructuredFormSection;
